export const getters = {
  factures (state) {
    return state.factures
  },
  facture (state) {
    return state.facture
  },  
  pagination(state){
    return state.pagination
  }
}
